<section class="contact" id="contact">
  <div class="container">
    <div class="section-header fade-in">
      <span class="section-subtitle">Kapcsolat</span>
      <h2 class="section-title">Látogass el hozzánk — Pákozd, Velencei-tó</h2>
    </div>

    <div class="contact__grid">
      <div class="contact__info fade-in">
        @if (restaurantConfig.contactInfo(); as c) {
          <div class="contact__block">
            <h3>Elérhetőségeink</h3>
            <div class="contact__item">
              <span class="contact__icon">📍</span>
              <div>
                <strong>Cím</strong>
                <p>{{ c.addressStreet }}, {{ c.addressZip }} {{ c.addressCity }}</p>
              </div>
            </div>
            <div class="contact__item">
              <span class="contact__icon">📞</span>
              <div>
                <strong>Telefon</strong>
                <p>
                  <a class="contact__link" [href]="'tel:' + phoneHref(c.phone)">{{ c.phone }}</a>
                </p>
              </div>
            </div>
            <div class="contact__item">
              <span class="contact__icon">✉️</span>
              <div>
                <strong>Email</strong>
                <p>
                  <a class="contact__link" [href]="'mailto:' + c.email">{{ c.email }}</a>
                </p>
              </div>
            </div>
          </div>
        } @else if (initialized()) {
          <div class="contact__block contact__block--muted">
            <p>Az elérhetőségeket nem sikerült betölteni.</p>
          </div>
        }

        <div class="contact__block">
          <h3>Nyitvatartás</h3>
          @if (openingHourRows().length) {
            <div class="contact__hours">
              @for (item of openingHourRows(); track item.day) {
                <div class="hours-row">
                  <span class="hours-day">{{ item.day }}</span>
                  <span class="hours-time">{{ item.hours }}</span>
                </div>
              }
            </div>
          } @else if (initialized()) {
            <p class="contact__muted">Nincs megadott nyitvatartás.</p>
          }
        </div>
      </div>

      @if (safeMapUrl(); as mapSrc) {
        <div class="contact__map fade-in">
          <iframe
            [src]="mapSrc"
            width="100%"
            height="100%"
            style="border: 0; border-radius: 8px"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            [title]="mapTitle()"
          ></iframe>
        </div>
      } @else if (initialized()) {
        <div class="contact__map contact__map--empty fade-in">
          <p class="contact__map-placeholder">Térkép nem áll rendelkezésre.</p>
        </div>
      }
    </div>
  </div>
</section>
